import { render } from "./BalLoadingBlock.vue?vue&type=template&id=23677398"
import script from "./BalLoadingBlock.vue?vue&type=script&lang=ts"
export * from "./BalLoadingBlock.vue?vue&type=script&lang=ts"

import "./BalLoadingBlock.vue?vue&type=style&index=0&id=23677398&lang=css"
script.render = render

export default script